import { Text } from '@contrast-security-inc/design-system-typography'
import React from 'react'

interface CheckLabelProps {
  value?: string
  count?: number
}

export const CheckLabel = ({ count, value }: CheckLabelProps) => {
  return (
    <Text as="div" font="body">
      {value}
      {typeof count !== 'undefined' && (
        <Text as="span" font="body" color="neutral70">
          {''} ({count})
        </Text>
      )}
    </Text>
  )
}
